/**
 * Admin module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import Dashboard from '@src/Admin/Pages/Components/Dashboard.vue';
import TextBlock from '@src/Admin/Pages/Blocks/TextBlock.vue';
import SingleKPIBlock from '@src/Admin/Pages/Blocks/SingleKPIBlock.vue';
import ColumnBlock from '@src/Admin/Pages/Blocks/ColumnBlock.vue';

export const setup = (app: App<Element>): void => {
    app.component('Dashboard', Dashboard);
    app.component('TextBlock', TextBlock);
    app.component('SingleKPIBlock', SingleKPIBlock);
    app.component('ColumnBlock', ColumnBlock);
};
